import { useState, useMemo, Fragment } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { StickyHeader, FiltersDr } from '../../components'
import {
  SearchTypesSelector,
  SearchTypesMobileSelector,
  BackListViewComponent,
  MobileFilters,
  SortingFilters,
  OpenWaterCourseWarning,
  SearchMap,
} from '../../components/search'
import {
  SORT_BY,
  filtersToClean,
  filtersKeys,
} from './search-parameters/resort-parameters'
import {
  setNumberOfTrips,
  setSearchFilters,
} from '../../actions/search-actions'
import {
  searchFiltersHook,
  searchOnInitHook,
} from '../../components/search/hooks'
import ResortComponent from '../../components/search-dr/ResortComponent'
import HeaderSelectedDateData from '../../components/search-dr/HeaderSelectedDateData'
import PropTypes from 'prop-types'

function ResortsSearch({
  pk,
  model,
  title,
  parentSlug,
  parentPk,
  parentModel,
  totalCount,
  searchFilters,
  inTitle,
  numberOfTrips,
  setNumberOfTrips,
  parentLiveaboardDetails,
  locationCoordinates,
  liveaboardDetails,
  isWidget,
  filters,
  trustpilotLocale,
  parentTitle,
  parentUrl,
  countryCode,
}) {
  const [numberOfBoatsParent, setNumberOfBoatsParent] = useState(0)
  const {
    transformedFilters,
    filtersCount,
    guests,
    updateParams,
    updateOrdering,
    showListView,
    triggerApi,
    clearSelectedFilters,
    clearDates,
  } = searchFiltersHook(filtersKeys, filtersToClean)
  searchOnInitHook(filtersKeys, 'resort')

  const isAllParamsSelected = useMemo(
    () =>
      transformedFilters.dateStart &&
      transformedFilters.nights &&
      guests.totalGuests,
    [
      transformedFilters.dateStart,
      transformedFilters.nights,
      guests.totalGuests,
    ],
  )

  const isMapView = transformedFilters.view === 'map'

  return (
    <div className='search-page-la search-page-dr'>
      {isMapView && <BackListViewComponent onClose={showListView} />}
      <StickyHeader
        locationTitle={title}
        selectedDates={
          <HeaderSelectedDateData selectedParams={transformedFilters} />
        }
        typeOfSearch={
          <FormattedMessage id='dive_resorts' defaultMessage='Dive resorts' />
        }
      />
      <div className={`search-wrapper ${isMapView ? 'full-width' : ''}`}>
        <div className='main-content'>
          <div className='results-head results-sort-wrapper display-flex content-s-b items-center'>
            <h1 className='hidden-xs'>
              <FormattedMessage
                id='search.title.resorts'
                values={{
                  qty: numberOfTrips,
                  location: inTitle,
                }}
                defaultMessage='{ qty, plural, one {# dive resort } other {# dive resorts } } { location }'
              />
            </h1>

            {!isWidget && (
              <div className='shop-types-search-page'>
                <SearchTypesSelector
                  activePage={window.typesData && window.typesData.activePage}
                />
                <SearchTypesMobileSelector
                  activePage={window.typesData && window.typesData.activePage}
                />
              </div>
            )}

            <SortingFilters
              updateOrdering={updateOrdering}
              orderingValue={transformedFilters.ordering}
              sortByItems={SORT_BY}
            />
          </div>
          {!isMapView && (
            <MobileFilters
              updateParams={updateParams}
              filtersCount={filtersCount}
              handleSortSelect={updateOrdering}
              selectedSorting={transformedFilters.ordering}
              sortOptions={SORT_BY}
            />
          )}
          <FiltersDr
            triggerApi={triggerApi}
            isWidget={isWidget}
            selectedFilters={searchFilters}
            items={filters}
            title={title}
            updateParams={updateParams}
            clearDates={clearDates}
            clearSelectedFilters={clearSelectedFilters}
            trustpilotLocale={trustpilotLocale}
            filtersCount={filtersCount}
            model={model}
            pk={pk}
            hideRange
          />
          <div className='result-list'>
            {isMapView ? (
              <SearchMap
                showListView={showListView}
                totalGuests={guests.totalGuests}
                isAllParamsSelected={isAllParamsSelected}
                selectedParams={transformedFilters}
                initLocation={locationCoordinates}
                isWidget={isWidget}
                countryCode={countryCode}
              />
            ) : (
              <Fragment>
                {!!transformedFilters.students &&
                  +transformedFilters.nights < 5 && <OpenWaterCourseWarning />}
                <ResortComponent
                  isAllParamsSelected={isAllParamsSelected}
                  setNumberOfItems={setNumberOfTrips}
                  selectedParams={transformedFilters}
                  getNewData={triggerApi}
                  numberOfTrips={numberOfTrips}
                  totalGuests={guests.totalGuests}
                  model={model}
                  isWidget={isWidget}
                  liveaboardDetails={liveaboardDetails}
                  pk={pk}
                />
                {totalCount < 10 && (
                  <div className='top-level-items'>
                    <h2>
                      <FormattedMessage
                        id='search.other_dr'
                        defaultMessage='{qty} other {qty, plural, one {dive resort} other {dive resorts}}'
                        values={{
                          qty: numberOfBoatsParent,
                        }}
                      />
                      &nbsp;
                      <span dangerouslySetInnerHTML={{ __html: parentTitle }} />
                    </h2>
                    <div className='update-search-wrapper'>
                      <a href={parentUrl} className='btn-red'>
                        <i className='font-icons find-icon' />
                        <FormattedMessage
                          id='update_search'
                          defaultMessage='Update search'
                        />
                      </a>
                      <span>
                        <FormattedMessage
                          id='search.dive_resorts_in'
                          defaultMessage='Dive resorts'
                        />
                        &nbsp;
                        <span
                          dangerouslySetInnerHTML={{ __html: parentTitle }}
                        />
                      </span>
                    </div>
                    <ResortComponent
                      isAllParamsSelected={isAllParamsSelected}
                      totalGuests={guests.totalGuests}
                      getNewData={triggerApi}
                      parentElement
                      setNumberOfItems={setNumberOfBoatsParent}
                      selectedParams={transformedFilters}
                      slug={parentSlug}
                      model={parentModel}
                      pk={parentPk}
                      liveaboardDetails={parentLiveaboardDetails}
                    />
                  </div>
                )}
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default connect(
  (state) => ({
    numberOfTrips: state.numberOfTrips,
    pageLoader: state.pageLoader,
    isNearBy: state.isNearBy,
    searchFilters: state.searchFilters,
  }),
  { setSearchFilters, setNumberOfTrips },
)(ResortsSearch)

ResortsSearch.propTypes = {
  pk: PropTypes.string,
  model: PropTypes.string,
  title: PropTypes.string,
  parentSlug: PropTypes.string,
  parentPk: PropTypes.string,
  parentModel: PropTypes.string,
  totalCount: PropTypes.number,
  inTitle: PropTypes.string,
  numberOfTrips: PropTypes.number,
  setNumberOfTrips: PropTypes.func,
  locationCoordinates: PropTypes.array,
  liveaboardDetails: PropTypes.object,
  parentLiveaboardDetails: PropTypes.object,
  countryCode: PropTypes.string,
  parentUrl: PropTypes.string,
  parentTitle: PropTypes.string,
  isWidget: PropTypes.bool,
  trustpilotLocale: PropTypes.string,
  searchFilters: PropTypes.object,
  filters: PropTypes.array,
}
